import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('form-modal');

export const OPEN_MODAL = getActionName('OPEN_MODAL');
export const UPDATE_CURRENT_MODAL_DATA = getActionName('UPDATE_CURRENT_MODAL_DATA');
export const CLOSE_MODAL = getActionName('CLOSE_MODAL');
